<template>
    <b-row>
        <b-col sm="12" md="6">
            <app-k-v
                titulo="Produto"
                :md="md"
                :lg="lg"
                :xl="xl"
                :dado="item.nomeProduto"
            ></app-k-v>
            <app-k-v
                titulo="Natureza"
                :md="md"
                :lg="lg"
                :xl="xl"
                :dado="item.nomeNatureza"
            ></app-k-v>
            <app-k-v
                titulo="Unidade"
                :md="md"
                :lg="lg"
                :xl="xl"
                :dado="item.nomeUnidade"
            ></app-k-v>
        </b-col>
        <b-col sm="12" md="6">
            <app-k-v
                titulo="Quantidade"
                :md="md"
                :lg="lg"
                :xl="xl"
            >
                <strong>{{ item.quantidade | currency2 }}</strong>
            </app-k-v>
            <app-k-v
                titulo="Valor Unitário"
                :md="md"
                :lg="lg"
                :xl="xl"
            >
                <strong>{{ item.valorUnitario | currency }}</strong>
            </app-k-v>
            <app-k-v
                titulo="Valor Total"
                :md="md"
                :lg="lg"
                :xl="xl"
            >
                <strong>{{ item.valor | currency }}</strong>
            </app-k-v>
            <app-k-v
                titulo="Rateios"
                :md="md"
                :lg="lg"
                :xl="xl"
            >
                <strong>{{ item.qtdRateios != null ? item.qtdRateios : 0 }}</strong>
            </app-k-v>
        </b-col>
    </b-row>
</template>

<script>

export default {
    props: {
        item: {
            type: Object,
        }
    },

    data() {
        return {
            xl: 3,
            lg: 3,
            md: 2
        }
    }
}

</script>